var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9163 3.25c-1.0374.73177-2.186 1.29145-3.4016 1.6575-.6525-.7502-1.5196-1.28192-2.4841-1.52325-.9645-.24133-1.9798-.18062-2.9087.17391-.9288.35453-1.7264.98577-2.2848 1.80837-.5584.82259-.8508 1.79683-.8374 2.79097v1.08333c-1.9038.04937-3.79031-.37287-5.49143-1.2291-1.70112-.85623-3.16409-2.11988-4.2586-3.6784 0 0-4.33333 9.74997 5.41667 14.08337-2.23109 1.5144-4.88891 2.2738-7.58333 2.1666C10.833 26 22.7497 20.5833 22.7497 8.125c-.001-.30176-.03-.60277-.0867-.89917 1.1057-1.09038 1.8859-2.46706 2.2533-3.97583z",
    stroke: "#fff",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.c84396535e7a8cfe79f3dcc49b227064.svg";
export { ForwardRef as ReactComponent };